define('controller/step/ServiceStep',['require','lib/controller/booking/BaseStep','underscore','collection/ServiceCollection','view/controller/booking/service/ServiceStepView','view/controller/booking/service/ServiceSplitterView','Config','lib/view/BookingUrlBuilder'],function (require) {

	var BaseStep = require('lib/controller/booking/BaseStep');
	var _ = require('underscore'); // pin to Underscore: global window._ may be a lodash build that drops the _.each context arg
	var ServiceCollection = require('collection/ServiceCollection');
	var ServiceStepView = require('view/controller/booking/service/ServiceStepView');
    var ServiceSplitterView = require('view/controller/booking/service/ServiceSplitterView');
	var Config = require('Config');
    var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');

    return BaseStep.extend({
		
		_step: 'service',
		_serviceCollection: null,
		
		/**
		 * Inits instance, collection, subscrib to events
		 */
		initialize: function() {
			var _this = this;
	        BaseStep.prototype.initialize.call(this);

			this._serviceCollection = new ServiceCollection();
			this._serviceCollection.fetch().done(function (result) {
				_this.triggerStepEvent('fetch_done', [result]);

			});
            this._serviceCollection.setComparator(_.bind(this.serviceComparator, this));

	        this.listenTo(this._bookingModel, 'change:service_id', this.updateInfo);
	        this.listenTo(this._serviceCollection, 'sync', this.onDataFetch);
	        // perform filter performers after all data fetched from server (like services, locations, etc.)
	        this.listenTo(this._stepManager, 'step:fetch', this.performCollectionFilters);
	        // on init provider step we add filter to filter only connected providers
	        this.listenTo(this._stepManager, 'step:init:provider', this.addProviderFilter);


            if (Config.getInstance().getPluginStatus('location')) {
                this.listenTo(this._stepManager, 'step:init:location', this.addLocationFilter);
            }
            if (Config.getInstance().getPluginStatus('event_category')) {
                this.listenTo(this._stepManager, 'step:init:category', this.addCategoryFilter);
            }
	    },

        /**
         * Triggers init event
         */
        triggerInit: function () {
            this.triggerStepEvent('init', [this, this._serviceCollection]);
        },

	    /**
	     * Returns step view
	     * 
	     * @return ServiceStepView
	     */
		getView: function () {
			var serviceStepView = new ServiceStepView({
				collection: this._serviceCollection
			});

            this.listenTo(serviceStepView, 'render:collection', this._onRenderCollection);

			return serviceStepView;
		},

        /**
         * Add splitters
         *
         * @private
         */
        _onRenderCollection: function (view) {
            if (this._serviceCollection.hasClassesAndServices()) {
                var servicePosition = this._serviceCollection.getFirstServiceIndex();
                var classPosition = this._serviceCollection.getFirstClassIndex();
                if (classPosition > servicePosition) {
                    classPosition++;
                }
                view.addChild(new Backbone.Model({'label': 'Services'}), ServiceSplitterView, servicePosition);
                view.addChild(new Backbone.Model({'label': 'Classes'}), ServiceSplitterView, classPosition);
            }
        },

		/**
		 * Calls when collection fetched from server
		 */
		onDataFetch: function () {
			this.triggerStepEvent('fetch', [this._serviceCollection]);
            this.updateInfo();

			if (this._serviceCollection.getDataCollection().length <= 1 && !Config.getInstance().getPluginStatus('group_booking')) {
				this._stepManager.hideStep('service');
			}

			this.done();
		},
		
		/**
		 * Updates booking info data
		 */
	    updateInfo: function () {
	   		this._bookingModel.set('service', this._serviceCollection.getDataCollection().getModelObj(
	    		this._bookingModel.get('service_id')
	    	));
	    },
	    
	    /**
	     * Apply filters to collection before show step view
	     */
	    beforeViewShow: function () {
	    	this.performCollectionFilters();
	    },

		/**
		 * Apply filters to collection before show step view
		 */
		performCollectionFilters: function () {
			this._serviceCollection.performFilters();
		},

	    /**
	     * Returns true if service is selected
	     * 
	     * @return Boolean
	     */
	    isValid: function () {
	    	this.performCollectionFilters();
			this._autoSelectItem();
            
            var serviceId = this._bookingModel.get('service_id');
            var service = this._serviceCollection.getModelObj(serviceId);
            if (serviceId) {
                if (
                    (this._serviceCollection.length && !service)
                    || (this._serviceCollection._once_synced && !this._serviceCollection.length)
                ) {
                    /*setTimeout(function () {
                        Backbone.history.navigate('error/e404', {
                            trigger: true,
                            replace: true
                        });
                    });*/
                }
            }

	    	if (this._bookingModel.get('service_id')) {
	    		return true;
	    	}
	    	return false;
	    },

        serviceComparator: function (model1, model2) {
	        var position1 = parseInt(model1.get('position'));
            var position2 = parseInt(model2.get('position'));
            var classCorrection = this._serviceCollection.getClassOrderCorrection(
                BookingUrlBuilder.getInstance().getBookingMode()
            );

            if (model1.get('class_id')) {
                position1 += classCorrection;
            }
            if (model2.get('class_id')) {
                position2 += classCorrection;
            }

            return position1 - position2;
        },

	    /**
	     * Adds filter to providers collection
	     */
	    addProviderFilter: function (step, collection) {
	    	collection.addFilter(_.bind(this.providerFilter, this));
	    },
        
        removeCollectionFilters: function () {
            collection.resetFilters();
        },
	    
	    /**
	     * Filters provider model
	     */
	    providerFilter: function (model) {
	    	if (model.get('id') === 'any') {
				return true;
			}

            var services = [];
            if (this._bookingModel.get('service_id')) {
                services.push(this._serviceCollection.get(
                    this._bookingModel.get('service_id')
                ));
            } else {
            	services = this._serviceCollection.toArray();
			}

			return _.some(services, function (service) {
                if (service) {
                    var unitMap = service.get('unit_map');
                    if (unitMap) { // service attached to list of certain units
                        if (unitMap.hasOwnProperty(model.get('id'))) { // given provider (model) is one of attached to the service
                            return true;
                        }
                    } else { // service not attached
                        // all performers allowed, except classes performer
                        return model.get('class_id') ? false : true;
                    }
                }
            }, this);
	    },

        locationFilter: function (model) {
            if (!this._bookingModel.get('service_id')) {
                return true;
            }
            if(!model.get('events')){
                return false;
            }

            var events = model.get('events') || [];
            events = _.map(events, function (val) { return parseInt(val)});

            return events.indexOf(parseInt(this._bookingModel.get('service_id'))) >= 0;
        },

        categoryFilter: function (model) {
	        return this.locationFilter(model); //code the same
        },

        /**
         * Adds filter to location collection
         */
        addLocationFilter: function (step, collection) {
            collection.addFilter(_.bind(this.locationFilter, this));
        },
        /**
         * Adds filter to category collection
         */
        addCategoryFilter: function (step, collection) {
            collection.addFilter(_.bind(this.categoryFilter, this));
        },

		/**
		 * Auto select service if collection contains single service
		 *
		 * @private
		 */
        _autoSelectItem: function () {
			this.setIsSkipped(false);
			if (this._serviceCollection.length === 1 && !Config.getInstance().getPluginStatus('group_booking')) {
                this.setIsSkipped(true);
			}

	        if (this._bookingModel.get('service_id')) {
                return;
            }

			if (this.isStepSkipped()) {
                var firstService = this._serviceCollection.first();

                if (firstService.get('id')) {
                    this._bookingModel.set('service_id', firstService.get('id'));
                }
            }
        }
	    
	});
	
});
